import '../css/app.css';
import '../css/style.css';
import './bootstrap';

import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import Layout from './Layouts/Layout.vue';
import {
    initGA4,
    trackPageView,
} from './services/analytics';


const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Initialize Google Analytics
initGA4();


createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) =>{
        
        const page = await resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        )
        page.default.layout = page.default.layout || Layout
        return page
    },
    setup({ el, App, props, plugin }) {
        
        return (
            createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .mount(el) 
        );
    },
    progress: {
        color: '#078b16ff',
    },
});


// Track Inertia navigation
router.on('navigate', (event) => {
    trackPageView(event.detail.page.url);
});